<template>
  <div id="dashboard">
    <PinSearchbox v-model:query="query" v-model:filter="filter" />
    <PinsDisplayer
      :pins="filteredPins"
      :pins-url="pinsUrl"
      @pin-created="userPins.push($event)"
      @pin-deleted="removePin"
      @pin-updated="updatePin"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import PinSearchbox from './PinSearchbox.vue'
import PinsDisplayer from './PinsDisplayer.vue'

const props = defineProps({
  pinsUrl: {
    type: String,
    required: true,
  },
})

const query = ref('')
const filter = ref('all')
const userPins = ref([])

function anyAccentRegex(str) {
  const replacements = {
    a: '[aáàâäåãæ]',
    á: '[aáàâäåãæ]',
    à: '[aáàâäåãæ]',
    â: '[aáàâäåãæ]',
    ä: '[aáàâäåãæ]',
    å: '[aáàâäåãæ]',
    ã: '[aáàâäåãæ]',
    æ: '[aáàâäåãæ]',
    c: '[cç]',
    ç: '[cç]',
    e: '[eéèêë]',
    é: '[eéèêë]',
    è: '[eéèêë]',
    ê: '[eéèêë]',
    ë: '[eéèêë]',
    i: '[iíìîï]',
    í: '[iíìîï]',
    ì: '[iíìîï]',
    î: '[iíìîï]',
    ï: '[iíìîï]',
    n: '[nñ]',
    ñ: '[nñ]',
    o: '[oóòôöõøœ]',
    ó: '[oóòôöõøœ]',
    ò: '[oóòôöõøœ]',
    ô: '[oóòôöõøœ]',
    ö: '[oóòôöõøœ]',
    õ: '[oóòôöõøœ]',
    ø: '[oóòôöõøœ]',
    œ: '[oóòôöõøœ]',
    s: '[sš]',
    š: '[sš]',
    u: '[uúùûü]',
    ú: '[uúùûü]',
    ù: '[uúùûü]',
    û: '[uúùûü]',
    ü: '[uúùûü]',
    y: '[yýÿ]',
    ý: '[yýÿ]',
    ÿ: '[yýÿ]',
    z: '[zž]',
    ž: '[zž]',
  }

  const re = new RegExp(Object.keys(replacements).join('|'), 'gi')
  const pattern = str.replace(re, (matched) => replacements[matched.toLowerCase()])
  return new RegExp(pattern, 'gui')
}

const filteredPins = computed(() => {
  const searchedPins =
    query.value === ''
      ? userPins.value
      : userPins.value.filter((pin) => {
          const regExp = anyAccentRegex(query.value)
          return regExp.test([pin.name, pin.city, pin.region, pin.country].join(' '))
        })

  if (filter.value === 'visited') {
    return searchedPins.filter((pin) => pin.visited)
  }

  if (filter.value === 'to_visit') {
    return searchedPins.filter((pin) => !pin.visited || pin.to_visit_again)
  }

  return searchedPins
})

async function refreshDestinations() {
  const response = await fetch(props.pinsUrl, { headers: { Accept: 'application/json' } })
  userPins.value = await response.json()
}

function removePin(pin) {
  userPins.value = userPins.value.filter((currentPin) => currentPin.id !== pin.id)
}

function updatePin(pin) {
  const index = userPins.value.findIndex((currentPin) => currentPin.id === pin.id)
  if (index >= 0) {
    userPins.value.splice(index, 1, pin)
  }
}

onMounted(refreshDestinations)
</script>
